// Impower re-renders the property form on reload, re-navigation and header actions. Hidden native UI is
// re-marked inside the MutationObserver callback, which runs before the browser paints, so it never flashes.
const LUX_NATIVE_INSURANCE_ATTR = 'data-lux-native-insurance'
const LUX_NATIVE_INSURANCE_LINK_ATTR = 'data-lux-native-insurance-link'
// The Lux overview is its own section, so the native section and its sidebar link are redirected to it.
// Only while every sub-section in it is hidden native UI; anything else keeps the native section reachable.
const LUX_NATIVE_INSURANCE_SECTION_ATTR = 'data-lux-native-insurance-section'
const LUX_HIDDEN_NATIVE_SUB_SECTIONS =
  '#insuranceIdentity, #insurance-weg, [id^="insurance-building-"], [id$="serviceProviders"], [data-lux-hide-objektdienste], [data-lux-hide-versorgung], .impowerx-insurance-lux-root'
const LUX_NATIVE_INSURANCE_NAV_ATTR = 'data-lux-native-insurance-nav'
const LUX_NATIVE_INSURANCE_LINK_RE =
  /^(Versicherungen|WEG Versicherungen|Wohngebäudeversicherung\b.*)$/
const LUX_NATIVE_INSURANCE_MAIN_LINK_RE = /Versicherungen|Dienstleister/
const LUX_PROPERTY_EDIT_PATH_RE = /^\/properties\/[A-Za-z0-9]+\/edit$/
// Section ids are stable, so only the <html> state (never re-rendered by Impower) decides their visibility.
const LUX_NATIVE_INSURANCE_STYLES = `
  html[${LUX_NATIVE_INSURANCE_ATTR}] .FormSection[${LUX_NATIVE_INSURANCE_SECTION_ATTR}],
  html[${LUX_NATIVE_INSURANCE_ATTR}] .sub-section:is(#insuranceIdentity, #insurance-weg, [id^="insurance-building-"]),
  html[${LUX_NATIVE_INSURANCE_ATTR}] .FormSidebar .Link.sub-link[${LUX_NATIVE_INSURANCE_LINK_ATTR}] { display:none !important; }
  html[${LUX_NATIVE_INSURANCE_ATTR}] .FormSidebar .Link.main-link[${LUX_NATIVE_INSURANCE_NAV_ATTR}] .arrow-wrapper { visibility:hidden; pointer-events:none; }
`

let nativePropertyUiObserver = null
let nativeInsuranceHoldTimer = null

function markNativeInsuranceSidebarLinks() {
  const replaceable = Boolean(
    document.querySelector(`.FormSection[${LUX_NATIVE_INSURANCE_SECTION_ATTR}]`)
  )
  document
    .querySelectorAll('.FormSidebar .Link.main-link')
    .forEach((mainLink) => {
      const title =
        mainLink.querySelector('.link-row.level1 .link-title')?.textContent ||
        ''
      const insuranceLink =
        mainLink.dataset.sectionId !== 'ContactRolesSection' &&
        LUX_NATIVE_INSURANCE_MAIN_LINK_RE.test(title)
      const redirected = insuranceLink && replaceable
      if (redirected !== mainLink.hasAttribute(LUX_NATIVE_INSURANCE_NAV_ATTR)) {
        mainLink.toggleAttribute(LUX_NATIVE_INSURANCE_NAV_ATTR, redirected)
      }
      mainLink.querySelectorAll('.Link.sub-link').forEach((link) => {
        const text = link.querySelector('.link-title')?.textContent.trim() || ''
        const native = insuranceLink && LUX_NATIVE_INSURANCE_LINK_RE.test(text)
        if (native === link.hasAttribute(LUX_NATIVE_INSURANCE_LINK_ATTR)) {
          return
        }
        if (native) link.setAttribute(LUX_NATIVE_INSURANCE_LINK_ATTR, '1')
        else link.removeAttribute(LUX_NATIVE_INSURANCE_LINK_ATTR)
      })
    })
}

function markNativeInsuranceSection() {
  const section =
    document.getElementById('ServiceProvider') ||
    document
      .querySelector(
        '#insuranceIdentity, #insurance-weg, [id^="insurance-building-"]'
      )
      ?.closest('.FormSection')
  if (!section || section.id === 'ContactRolesSection') return
  const onlyHiddenUi = [...section.querySelectorAll('.sub-section')].every(
    (sub) => sub.matches(LUX_HIDDEN_NATIVE_SUB_SECTIONS)
  )
  if (
    onlyHiddenUi !== section.hasAttribute(LUX_NATIVE_INSURANCE_SECTION_ATTR)
  ) {
    section.toggleAttribute(LUX_NATIVE_INSURANCE_SECTION_ATTR, onlyHiddenUi)
  }
}

function isNativeInsuranceSectionReplaceable(section) {
  return Boolean(section?.hasAttribute(LUX_NATIVE_INSURANCE_SECTION_ATTR))
}

function hideNativePropertyUi() {
  if (!LUX_PROPERTY_EDIT_PATH_RE.test(window.location?.pathname)) return
  if (typeof hideObjektdiensteBuildingServiceUi === 'function') {
    hideObjektdiensteBuildingServiceUi()
  }
  if (typeof hideVersorgungBuildingServiceUi === 'function') {
    hideVersorgungBuildingServiceUi()
  }
  markNativeInsuranceSection()
  markNativeInsuranceSidebarLinks()
}

/** Installed once per page load and kept across property re-injects. */
function keepNativePropertyUiHidden() {
  if (!document.getElementById('luxNativeInsuranceStyles')) {
    const style = document.createElement('style')
    style.id = 'luxNativeInsuranceStyles'
    style.textContent = LUX_NATIVE_INSURANCE_STYLES
    document.head.appendChild(style)
  }
  hideNativePropertyUi()
  if (nativePropertyUiObserver) return
  nativePropertyUiObserver = new MutationObserver(hideNativePropertyUi)
  nativePropertyUiObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  })
}

/** Hides native insurance while the Lux overview of this property loads. */
function holdNativeInsuranceUi(propertyHrId) {
  keepNativePropertyUiHidden()
  const html = document.documentElement
  if (
    html.getAttribute(LUX_NATIVE_INSURANCE_ATTR) === 'replaced' &&
    html.dataset.luxNativeInsuranceProperty === propertyHrId
  ) {
    return
  }
  html.setAttribute(LUX_NATIVE_INSURANCE_ATTR, 'pending')
  html.dataset.luxNativeInsuranceProperty = propertyHrId
  clearTimeout(nativeInsuranceHoldTimer)
  // If the overview never mounts (e.g. the inject failed) the native forms come back.
  nativeInsuranceHoldTimer = setTimeout(() => {
    if (html.getAttribute(LUX_NATIVE_INSURANCE_ATTR) === 'pending') {
      releaseNativeInsuranceUi()
    }
  }, LUX_INSURANCE_PENDING_TIMEOUT_MS)
}

/** Once the Lux overview is mounted the native insurance forms stay hidden. */
function replaceNativeInsuranceUi(propertyHrId) {
  keepNativePropertyUiHidden()
  clearTimeout(nativeInsuranceHoldTimer)
  const html = document.documentElement
  html.setAttribute(LUX_NATIVE_INSURANCE_ATTR, 'replaced')
  html.dataset.luxNativeInsuranceProperty = propertyHrId
}

function releaseNativeInsuranceUi() {
  clearTimeout(nativeInsuranceHoldTimer)
  const html = document.documentElement
  html.removeAttribute(LUX_NATIVE_INSURANCE_ATTR)
  delete html.dataset.luxNativeInsuranceProperty
}

function isNativeInsuranceReplaced() {
  return (
    document.documentElement.getAttribute(LUX_NATIVE_INSURANCE_ATTR) ===
    'replaced'
  )
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    LUX_NATIVE_INSURANCE_NAV_ATTR,
    keepNativePropertyUiHidden,
    holdNativeInsuranceUi,
    replaceNativeInsuranceUi,
    releaseNativeInsuranceUi,
    isNativeInsuranceReplaced,
    isNativeInsuranceSectionReplaceable,
    markNativeInsuranceSidebarLinks,
  }
}
